// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.card-intersection[data-v-ca6f6d62]{height:100%}.wrapper[data-v-ca6f6d62]{width:100%}.card-col[data-v-ca6f6d62]{padding:0 .4rem .8rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
